const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolitiker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 647.39 564.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b4ea02d6-02ee-4955-ac6c-7ddd06ece523",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1a7e64b-f6c3-4c40-8d66-e197f7d7d37f",
    "data-name": "b0f35fe8-0104-458a-8f81-ef42473ec9c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.47,527.54,617.6,467,603.68,531s.18,16.16.64,33.86h17.84C622.76,544.65,622.47,527.54,622.47,527.54Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.88,549.08a123.81,123.81,0,0,1-2.9-17.22l-2-20.95c-.82-5.74-1.66-10.8-2.51-15.26-6.2-31.83-12.61-33-12.61-33-.28.21-.55.45-.82.69a20.92,20.92,0,0,0-2.1,2.21c-10.21,13-17.13,46.62-20.77,68.94-2,12.33-3,21.2-3,21.2s.91,3.78,2.15,9.17h46.58A83.3,83.3,0,0,0,371.88,549.08Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.89,
    cy: 129.88,
    rx: 95,
    ry: 86.45,
    style: {
      fill: "#e1e1ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.39,412.38h0s32-22,32-32,22-75,34-46-17,70-17,70-32,58-51,68-35,4-35,4v-27l18.28-27.06A22.61,22.61,0,0,1,308.39,412.38Z",
    style: {
      fill: "#eaabab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.43,259.22s48,15.16,53,22.16,7-5,21,41,17.5,90.5,17.5,90.5-34.5,11.5-30.5,56.5-6,94-6,94H259.91l-27.52-85,33-129S218.48,270.05,217.43,259.22Z",
    style: {
      fill: "#fdbe26"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.39,
    cy: 157.38,
    r: 60,
    style: {
      fill: "#eaabab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.39,202.38s-17,56-2,64,32,44,32,44l-26,29h-60l-27-30-11-51,15-12s16-40,16-61S224.39,202.38,224.39,202.38Z",
    style: {
      fill: "#eaabab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,264.38s-12-3-5,9,14,34-11,35-50-12-58-39-11-25-14-24-35,34-35,34l11,62,4,222h146s6-64-4-79,9-53,9-53,17-26,4-76S234.39,264.38,229.39,264.38Z",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,245.38s-15-7-28,5-42,22-42,28,25,177,8,207-35,78-35,78H134.8s13.59-50,27.59-77,13-103,9-126S148.39,245.38,148.39,245.38Z",
    style: {
      fill: "#fdbe26"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.39 510.38 65.26 563.38 119.31 563.38 114.39 497.38 60.39 510.38",
    style: {
      fill: "#eaabab"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.39 482.38 319.39 563.38 608.39 563.38 633.39 400.38 306.39 482.38",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.39 389.38 647.39 404.38 273.39 494.38 273.39 481.38 644.39 389.38",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.39 416.38 484.39 433.38 506.39 430.38 497.39 413.38 486.39 416.38",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39,244.38s44-3,56,31,40,95,51,104,23,33,21,41",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,243.88c0,4.7-5,8.5-13,8.5s-12-3.8-12-8.5,4-8.5,12-8.5S371.89,239.19,371.89,243.88Z",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.89,399.88s7.5-31.5-6.5-77.5-16-34-21-41-53-22.16-53-22.16c.35,3.56,5.64,14.52,12.6,27.62a53.2,53.2,0,0,0-5.64-13.46c-7-12,5-9,5-9,5,0,34,41,47,91s-4,76-4,76Z",
    style: {
      fill: "#fdbe26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.89,258.88s5.92,22.46,11,25.73,34.93,34.33,34.93,34.33l-3.89-25.06-16-24-4.26-3.09Z",
    style: {
      fill: "#fdbe26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.89,327.88l1.39-51.5s-32.89,14-35.89,74,5,173,16,174,63-11,63-11,8-145,5-164S84.89,327.88,84.89,327.88Z",
    style: {
      isolation: "isolate",
      opacity: 0.10000000149011612
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.39,276.38H79.28s-32.89,14-35.89,74,5,173,16,174,63-11,63-11,8-145,5-164S87.39,276.38,87.39,276.38Z",
    style: {
      fill: "#fdbe26"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.89,
    cy: 141.38,
    rx: 62,
    ry: 69.5,
    style: {
      fill: "#e1e1ea"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.39,
    cy: 179.38,
    rx: 12.5,
    ry: 18.5,
    style: {
      fill: "#eaabab"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.89,
    cy: 71.88,
    r: 51,
    style: {
      fill: "#e1e1ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.48,112.74A51,51,0,0,1,.59,72.13,51,51,0,1,0,101.77,75,51,51,0,0,1,74.48,112.74Z",
    style: {
      fill: "#e1e1ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.91,80.31A51,51,0,0,1,65.59,0,51,51,0,1,0,82.22,99.84,50.93,50.93,0,0,1,39.91,80.31Z",
    style: {
      fill: "#e1e1ea"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.89,
    cy: 110.88,
    rx: 36,
    ry: 26,
    style: {
      fill: "#e1e1ea"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitiker);
export default __webpack_public_path__ + "static/media/politiker.9b58efbb33691d79e88a3b62a35bc1d8.svg";
export { ForwardRef as ReactComponent };